import { useRef } from 'react'
import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/lastViewed.svg'
import { ActivityEventPosition, ArticleLastViewedEvent } from './Types'
import Styles from './ActivityEvent.module.scss'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver'
import { ArticleLastViewedLocator } from './ArticleLastViewedLocator'

interface Props extends ActivityEventPosition {
  event: ArticleLastViewedEvent
}

const ArticleLastViewed = ({ event, ...props }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const entry = useIntersectionObserver(ref, { rootMargin: '-164px 0px 0px 0px' })

  return (
    <>
      <BaseActivityEvent
        {...props}
        ref={ref}
        icon={<Icon />}
        timestamp={event.timestamp}
        className={Styles.lastViewedContainer}
        content={<span className={Styles.lastViewedContent}>Last time you were here</span>}
        actions={null}
      />
      <ArticleLastViewedLocator entry={entry} />
    </>
  )
}

export { ArticleLastViewed }
